<div class="un-matched-xray">
  <div class="un-matched-xray-section">
    <div class="text-danger heading">
      Unable to match X-Ray Images
      <span class="badge bg-danger">{{ studyFiles?.length }}</span>
    </div>

    <div class="row">
      <div
        *ngFor="let studyFile of studyFiles; trackBy: trackByStudyFile"
        class="col-md-2"
      >
        <div class="xray-wrapper">
          <app-xray-item
            [studyFile]="studyFile"
            [mediaCategories]="mediaCategories"
             [mediaGroups]="mediaGroups"
            [isUnknown]="true"
            [isEditable]="true"
            (changeCategoryClicked)="emitChangeMediaCategory($event)"
            (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
            (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
                         (viewImage)="viewImage($event)"
          ></app-xray-item>
        </div>
      </div>
    </div>
  </div>
</div>
